<ul class="content-card-actions">
    <ng-content></ng-content>
</ul>